// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#total-grid {
  border: 1px solid white;
}

button.submit-btn.actionButton.button.button-md.button-default.button-default-md.button-full.button-full-md:hover {
  opacity: 0.7 !important;
}

button.submit-btn.actionButton.button.button-md.button-default.button-default-md:hover {
  opacity: 0.7 !important;
}

button.button.button-md.button-default.button-default-md.button-full.button-full-md.button-md-light:hover {
  opacity: 0.5 !important;
}

span.hoverClick:hover {
  opacity: 0.7 !important;
}

.inputItem {
  font-size: 14px;
  background: white;
  border: 2px solid #efefef;
  border-radius: 5px;
  height: 40px;
  margin: 0px;
}

.labelContent {
  position: relative;
  font-size: 14px;
  top: 1px;
  color: white;
  float: right;
}

.upload-btn {
  padding-top: 5px;
}

.labelContentMbl {
  position: relative;
  font-size: 14px;
  top: 1px;
  color: white;
}

.row {
  padding-top: 12px;
}

#memberAccountForm fieldset:not(:first-of-type) {
  display: none;
}

fieldset {
  border: none;
}

.error-text {
  text-align: left;
  font-size: 14px;
  height: 0px;
}

.e-input-group {
  width: 100% !important;
  border-width: 1px 1px 1px 1px !important;
  border: 2px solid #efefef !important;
  border-radius: 5px !important;
  height: 40px !important;
  background: white !important;
}

.e-input-group input.e-input,
.e-input-group input,
.e-input-group.e-control-wrapper input.e-input,
.e-input-group.e-control-wrapper input {
  padding-left: 10px;
  padding-top: 10px;
}

.e-input-group input.e-input:focus,
.e-input-group.e-control-wrapper input.e-input:focus {
  padding-left: 10px;
  padding-top: 10px;
}

.e-input-group.e-control-wrapper .e-input-group-icon:last-child {
  margin-right: 6px !important;
  padding-top: 6px !important;
}

#relations_popup,
#child_popup {
  overflow-y: scroll;
}

.e-input {
  font-size: 14px;
}

.e-multiselect.e-input-group {
  padding-left: 10px !important;
}

span.e-searcher {
  padding-top: 3px;
}

.maskinput {
  font-size: 14px !important;
  width: 100%;
  letter-spacing: 1px;
  color: black;
}

#uploadLabelForAddAthlete {
  background: #dfdfdf;
  padding: 6px;
  border-radius: 15px;
  font-size: 11px;
  position: relative;
  top: 15px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  text-align: center;
  color: black;
}

.text-input {
  margin: 10px 8px !important;
}

.privacyterms {
  font-size: 13px;
  color: rgba(0, 0, 0, 0.87);
  padding-left: 7px;
  position: relative;
  margin: auto 0;
  color: #9ca579;
}

li {
  color: white;
}

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

#previmg {
  position: relative;
  border-radius: 50%;
  bottom: 5px;
  object-fit: cover;
}

@media only screen and (max-width: 500px) {
  .label-text {
    text-align: left !important;
  }
  #total-grid {
    width: 100% !important;
  }
  .row {
    padding-top: 0px !important;
  }
  .labelContent {
    top: 1px !important;
  }
  .removableCol {
    display: none !important;
  }
  #privacyCheckBox {
    margin-left: 0px !important;
  }
  #previmg {
    top: 25px !important;
  }
}
.footer {
  text-align: center;
  font-size: 11px;
  font-style: italic;
  color: white;
  background: #be1e2d;
}

.creation-success {
  color: #00c09a;
  font-size: 26px;
  font-weight: 500;
}

.stepper {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.step {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
}

.step:after {
  content: "";
  display: block;
  width: 100%;
  position: relative;
  height: 5px;
  background: #dee3e4;
}

.step:before {
  content: "";
  display: block;
  width: 100%;
  position: relative;
  height: 5px;
  background: #dee3e4;
}

.step:last-child {
  flex-basis: 70%;
}

.step:last-child:after {
  display: none;
}

.step:first-child {
  flex-basis: 70%;
}

.step:first-child:before {
  display: none;
}

.step.active {
  color: white;
}

.step.active:before,
.step.active:after {
  background-color: #00c09a;
}

.step.active + .step:not(.active):before {
  background-color: #00c09a;
}

.step-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.step-circle {
  border-radius: 20px;
}

.label-div {
  position: relative;
  bottom: 100%;
  right: 0.8%;
  top: -15px;
}

.info-content {
  font-size: 11px;
  color: white;
}

.header-row {
  padding-top: 0px !important;
}

.e-multiselect.e-input-group.e-input-focus {
  height: auto !important;
}

.e-checkbox-wrapper .e-frame.e-check {
  background-color: #be1e2d !important;
}

.e-checkbox-wrapper:hover .e-frame.e-check {
  background-color: #be1e2d !important;
}

.e-checkbox-wrapper .e-checkbox:focus + .e-frame.e-check {
  background-color: #be1e2d !important;
}

@media only screen and (max-width: 768px) {
  #total-grid {
    border: 1px solid transparent;
    width: 75% !important;
  }
}
.dropdown-btn {
  background: #fff;
  min-height: 34px !important;
  font-size: 14px;
  border: 1px solid #adadad;
  color: #adadad;
}

#sports_position_codes span {
  color: #adadad;
}

#sports_position_codes .dropdown-list {
  font-size: 14px;
}

#sports_position_codes span.selected-item {
  background: gray !important;
  color: #fff !important;
  border: 1px solid gray;
  border-radius: 5px;
  margin-bottom: 10px;
}

input[type=checkbox] + div:before {
  border: 2px solid #be1e2d !important;
}

input[type=checkbox]:disabled + div:before {
  border-color: #ccc !important;
}

input[type=checkbox]:checked + div:before {
  background: #be1e2d !important;
  border: 2px solid #be1e2d !important;
}

.multiSelectDisabled {
  pointer-events: none;
}

.multiSelectActive {
  pointer-events: unset;
}

.uploadButton {
  color: white;
  font-size: 14px;
  margin-right: 20px;
  margin-top: 10px;
  background-color: #be1e2d;
  height: 30px;
  text-transform: uppercase;
  width: 100px;
  font-weight: 500;
  border-radius: 5%;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
}

span.e-input-group.e-control-wrapper.e-date-wrapper {
  margin-top: 8px;
}

button[disabled] {
  cursor: default;
  opacity: 0.4;
  pointer-events: none;
}

.actionButton {
  width: 100%;
  color: #ffffff;
  background: #be1e2d;
  height: 42px;
  font-size: 14px;
  margin-top: 15px;
}

#sports_position_codes span.dropdown-btn {
  background: #fff;
  min-height: 34px !important;
  font-size: 14px;
  border: 1px solid #adadad;
  color: #adadad;
}

#athleteBirthdate_input {
  padding-left: 10px;
  padding-top: 10px;
}

.cancel-btn {
  height: 42px;
  opacity: 0.7;
  width: 100%;
  background-color: #f4f4f4;
  color: black;
  margin-top: 15px;
  font-size: 14px;
}

.add-btn {
  background: transparent;
  border-radius: 4px;
  border: 1px solid #be1e2d;
  color: #be1e2d;
  font-size: 14px;
  height: 42px;
  width: 100%;
}

.select-btn {
  color: #ffffff;
  font-size: 14px;
  background: #be1e2d;
  height: 42px;
  width: 100%;
}

.e-popup.e-multi-select-list-wrapper {
  padding-top: calc(1px + env(safe-area-inset-top)) !important;
}

::ng-deep .addathlete-popover {
  --width:278px;
}
::ng-deep .addathlete-popover .popover-viewport.sc-ion-popover-ios {
  overflow-y: auto;
}
::ng-deep .addathlete-popover ion-item {
  --inner-border-width: 0;
  --background: #ffffff;
  background: #ffffff;
  --color: #000000;
  color: #000000;
  font-size: 13px !important;
  height: 36px;
  --background-focused-opacity: 0.08 !important;
  --background-hover-opacity: 0.08 !important;
}
::ng-deep .addathlete-popover ion-item ion-label {
  color: #000000 !important;
  --color: #000000 !important;
}
::ng-deep .addathlete-popover ion-item ion-radio {
  --color-checked: #be1e2d !important;
}

::ng-deep .level-popover {
  --width:278px;
}
::ng-deep .level-popover ion-item {
  --inner-border-width: 0;
  --background: #ffffff;
  background: #ffffff;
  --color: #000000;
  color: #000000;
  font-size: 13px !important;
  height: 36px;
  --background-focused-opacity: 0.08 !important;
  --background-hover-opacity: 0.08 !important;
}
::ng-deep .level-popover ion-item ion-label {
  color: #000000 !important;
  --color: #000000 !important;
}
::ng-deep .level-popover ion-item ion-radio {
  --color-checked: #be1e2d !important;
}

input.maskinput:focus {
  border: none;
  outline-width: 0;
  outline: 0;
}

#athletePhoneNumber {
  padding: 7px;
  font-size: 14px;
}

ion-input {
  margin: 0px;
}

@media only screen and (max-width: 550px) {
  #total-grid {
    width: 90%;
  }
  ::ng-deep .addathlete-popover {
    --width:390px ;
  }
  ::ng-deep .level-popover {
    --width:390px ;
  }
}
::ng-deep .addathlete-popovermobile {
  --width: 66%;
  left: 0px;
}
::ng-deep .addathlete-popovermobile .popover-viewport.sc-ion-popover-ios {
  overflow-y: auto;
}
::ng-deep .addathlete-popovermobile ion-item {
  --inner-border-width: 0;
  --background: #ffffff;
  background: #ffffff;
  --color: #000000;
  color: #000000;
  font-size: 13px !important;
  height: 36px;
  --background-focused-opacity: 0.08 !important;
  --background-hover-opacity: 0.08 !important;
}
::ng-deep .addathlete-popovermobile ion-item ion-label {
  color: #000000 !important;
  --color: #000000 !important;
}
::ng-deep .addathlete-popovermobile ion-item ion-radio {
  --color-checked:#be1e2d!important;
}

::ng-deep .addathlete-heightfeet-popover {
  --width:133px;
}
::ng-deep .addathlete-heightfeet-popover .popover-viewport.sc-ion-popover-ios {
  overflow-y: auto;
}
::ng-deep .addathlete-heightfeet-popover ion-item {
  --inner-border-width: 0;
  --background: #ffffff;
  background: #ffffff;
  --color: #000000;
  color: #000000;
  font-size: 13px !important;
  height: 36px;
  --background-focused-opacity: 0.08 !important;
  --background-hover-opacity: 0.08 !important;
}
::ng-deep .addathlete-heightfeet-popover ion-item ion-label {
  color: #000000 !important;
  --color: #000000 !important;
}
::ng-deep .addathlete-heightfeet-popover ion-item ion-radio {
  --color-checked: #be1e2d !important;
}

::ng-deep .level-popovermobile {
  --width: 66%;
  left: 0px;
  --height: 40% !important;
}
::ng-deep .level-popovermobile ion-item {
  --inner-border-width: 0;
  --background: #ffffff;
  background: #ffffff;
  --color: #000000;
  color: #000000;
  font-size: 13px !important;
  height: 36px;
  --background-focused-opacity: 0.08 !important;
  --background-hover-opacity: 0.08 !important;
}
::ng-deep .level-popovermobile ion-item ion-label {
  color: #000000 !important;
  --color: #000000 !important;
}
::ng-deep .level-popovermobile ion-item ion-radio {
  --color-checked:#be1e2d!important;
}

.e-multiselect .e-down-icon .e-chips-close.e-close-hooker {
  margin-top: -30px !important;
}

.e-multi-select-wrapper .e-delim-values {
  line-height: 35px !important;
}

.e-multiselect .e-input-group-icon.e-ddl-icon {
  margin-top: 9px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/add-athlete/add-athlete.page.scss"],"names":[],"mappings":"AAAA;EACI,uBAAA;AACJ;;AAEA;EACI,uBAAA;AACJ;;AAEA;EACI,uBAAA;AACJ;;AAEA;EACI,uBAAA;AACJ;;AAEA;EACI,uBAAA;AACJ;;AAEA;EACI,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;AACJ;;AAEA;EACI,kBAAA;EACA,eAAA;EACA,QAAA;EACA,YAAA;EACA,YAAA;AACJ;;AAEA;EACI,gBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,eAAA;EACA,QAAA;EACA,YAAA;AACJ;;AAEA;EACI,iBAAA;AACJ;;AAEA;EACI,aAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,gBAAA;EACA,eAAA;EACA,WAAA;AACJ;;AAEA;EACI,sBAAA;EACA,wCAAA;EACA,oCAAA;EACA,6BAAA;EACA,uBAAA;EACA,4BAAA;AACJ;;AAEA;;;;EAII,kBAAA;EACA,iBAAA;AACJ;;AAEA;;EAEI,kBAAA;EACA,iBAAA;AACJ;;AAEA;EACI,4BAAA;EACA,2BAAA;AACJ;;AAEA;;EAEI,kBAAA;AACJ;;AAEA;EACI,eAAA;AACJ;;AAEA;EACI,6BAAA;AACJ;;AAEA;EACI,gBAAA;AACJ;;AAEA;EACI,0BAAA;EACA,WAAA;EACA,mBAAA;EACA,YAAA;AACJ;;AAEA;EACI,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,SAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;AACJ;;AAEA;EACI,2BAAA;AACJ;;AAEA;EACI,eAAA;EACA,0BAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,cAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;;EAEI,wBAAA;EACA,SAAA;AACJ;;AAEA;EACI,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,iBAAA;AACJ;;AAEA;EACI;IACI,2BAAA;EACN;EAEE;IACI,sBAAA;EAAN;EAGE;IACI,2BAAA;EADN;EAIE;IACI,mBAAA;EAFN;EAKE;IACI,wBAAA;EAHN;EAME;IACI,2BAAA;EAJN;EAOE;IACI,oBAAA;EALN;AACF;AAQA;EACI,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;AANJ;;AASA;EACI,cAAA;EACA,eAAA;EACA,gBAAA;AANJ;;AASA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;AANJ;;AASA;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;AANJ;;AASA;EACI,WAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;AANJ;;AASA;EACI,WAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;AANJ;;AASA;EACI,eAAA;AANJ;;AASA;EACI,aAAA;AANJ;;AASA;EACI,eAAA;AANJ;;AASA;EACI,aAAA;AANJ;;AASA;EACI,YAAA;AANJ;;AASA;;EAEI,yBAAA;AANJ;;AASA;EACI,yBAAA;AANJ;;AASA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AANJ;;AASA;EACI,mBAAA;AANJ;;AASA;EACI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;AANJ;;AASA;EACI,eAAA;EACA,YAAA;AANJ;;AASA;EACI,2BAAA;AANJ;;AASA;EACI,uBAAA;AANJ;;AASA;EACI,oCAAA;AANJ;;AASA;EACI,oCAAA;AANJ;;AASA;EACI,oCAAA;AANJ;;AASA;EACI;IACI,6BAAA;IACA,qBAAA;EANN;AACF;AASA;EACI,gBAAA;EACA,2BAAA;EACA,eAAA;EACA,yBAAA;EACA,cAAA;AAPJ;;AAUA;EACI,cAAA;AAPJ;;AAUA;EACI,eAAA;AAPJ;;AAUA;EACI,2BAAA;EACA,sBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;AAPJ;;AAUA;EACI,oCAAA;AAPJ;;AAUA;EACI,6BAAA;AAPJ;;AAUA;EACI,8BAAA;EACA,oCAAA;AAPJ;;AAUA;EACI,oBAAA;AAPJ;;AAUA;EACI,qBAAA;AAPJ;;AAUA;EACI,YAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,YAAA;EACA,yBAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EAGA,+GAAA;AARJ;;AAWA;EACI,eAAA;AARJ;;AAWA;EACI,eAAA;EACA,YAAA;EACA,oBAAA;AARJ;;AAWA;EACI,WAAA;EACA,cAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AARJ;;AAWA;EACI,gBAAA;EACA,2BAAA;EACA,eAAA;EACA,yBAAA;EACA,cAAA;AARJ;;AAWA;EACI,kBAAA;EACA,iBAAA;AARJ;;AAWA;EACI,YAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;AARJ;;AAWA;EACI,uBAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;AARJ;;AAWA;EACI,cAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;AARJ;;AAWA;EACI,4DAAA;AARJ;;AAWA;EACI,aAAA;AARJ;AAWI;EACI,gBAAA;AATR;AAYI;EACI,uBAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,0BAAA;EACA,YAAA;EACA,6CAAA;EACA,2CAAA;AAVR;AAYQ;EACI,yBAAA;EACA,2BAAA;AAVZ;AAaQ;EACI,mCAAA;AAXZ;;AAiBA;EACI,aAAA;AAdJ;AAeI;EACI,uBAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,0BAAA;EACA,YAAA;EACA,6CAAA;EACA,2CAAA;AAbR;AAeQ;EACI,yBAAA;EACA,2BAAA;AAbZ;AAgBQ;EACI,mCAAA;AAdZ;;AAmBA;EACI,YAAA;EACA,gBAAA;EACA,UAAA;AAhBJ;;AAmBA;EACI,YAAA;EACA,eAAA;AAhBJ;;AAmBA;EACI,WAAA;AAhBJ;;AAmBA;EACI;IACI,UAAA;EAhBN;EAkBE;IACI,cAAA;EAhBN;EAmBE;IACI,cAAA;EAjBN;AACF;AAsBA;EACI,YAAA;EACA,SAAA;AApBJ;AAqBI;EACI,gBAAA;AAnBR;AAqBI;EACI,uBAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,0BAAA;EACA,YAAA;EACA,6CAAA;EACA,2CAAA;AAnBR;AAoBQ;EACI,yBAAA;EACA,2BAAA;AAlBZ;AAoBQ;EACI,iCAAA;AAlBZ;;AAuBA;EACI,aAAA;AApBJ;AAuBI;EACI,gBAAA;AArBR;AAwBI;EACI,uBAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,0BAAA;EACA,YAAA;EACA,6CAAA;EACA,2CAAA;AAtBR;AAwBQ;EACI,yBAAA;EACA,2BAAA;AAtBZ;AAyBQ;EACI,mCAAA;AAvBZ;;AA4BA;EACI,YAAA;EACA,SAAA;EACA,wBAAA;AAzBJ;AA0BI;EACI,uBAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,0BAAA;EACA,YAAA;EACA,6CAAA;EACA,2CAAA;AAxBR;AAyBQ;EACI,yBAAA;EACA,2BAAA;AAvBZ;AAyBQ;EACI,iCAAA;AAvBZ;;AA4BA;EACC,4BAAA;AAzBD;;AA4BA;EACI,4BAAA;AAzBJ;;AA4BA;EACI,0BAAA;AAzBJ","sourcesContent":["#total-grid {\n    border: 1px solid white;\n}\n\nbutton.submit-btn.actionButton.button.button-md.button-default.button-default-md.button-full.button-full-md:hover {\n    opacity: 0.7 !important;\n}\n\nbutton.submit-btn.actionButton.button.button-md.button-default.button-default-md:hover {\n    opacity: 0.7 !important;\n}\n\nbutton.button.button-md.button-default.button-default-md.button-full.button-full-md.button-md-light:hover {\n    opacity: 0.5 !important;\n}\n\nspan.hoverClick:hover {\n    opacity: 0.7 !important;\n}\n\n.inputItem {\n    font-size: 14px;\n    background: white;\n    border: 2px solid #efefef;\n    border-radius: 5px;\n    height: 40px;\n    margin: 0px;\n}\n\n.labelContent {\n    position: relative;\n    font-size: 14px;\n    top: 1px;\n    color: white;\n    float: right;\n}\n\n.upload-btn {\n    padding-top: 5px;\n}\n\n.labelContentMbl {\n    position: relative;\n    font-size: 14px;\n    top: 1px;\n    color: white;\n}\n\n.row {\n    padding-top: 12px;\n}\n\n#memberAccountForm fieldset:not(:first-of-type) {\n    display: none;\n}\n\nfieldset {\n    border: none;\n}\n\n.error-text {\n    text-align: left;\n    font-size: 14px;\n    height: 0px;\n}\n\n.e-input-group {\n    width: 100% !important;\n    border-width: 1px 1px 1px 1px !important;\n    border: 2px solid #efefef !important;\n    border-radius: 5px !important;\n    height: 40px !important;\n    background: white !important;\n}\n\n.e-input-group input.e-input,\n.e-input-group input,\n.e-input-group.e-control-wrapper input.e-input,\n.e-input-group.e-control-wrapper input {\n    padding-left: 10px;\n    padding-top: 10px;\n}\n\n.e-input-group input.e-input:focus,\n.e-input-group.e-control-wrapper input.e-input:focus {\n    padding-left: 10px;\n    padding-top: 10px;\n}\n\n.e-input-group.e-control-wrapper .e-input-group-icon:last-child {\n    margin-right: 6px !important;\n    padding-top: 6px !important;\n}\n\n#relations_popup,\n#child_popup {\n    overflow-y: scroll;\n}\n\n.e-input {\n    font-size: 14px;\n}\n\n.e-multiselect.e-input-group {\n    padding-left: 10px !important;\n}\n\nspan.e-searcher {\n    padding-top: 3px;\n}\n\n.maskinput {\n    font-size: 14px !important;\n    width: 100%;\n    letter-spacing: 1px;\n    color: black;\n}\n\n#uploadLabelForAddAthlete {\n    background: #dfdfdf;\n    padding: 6px;\n    border-radius: 15px;\n    font-size: 11px;\n    position: relative;\n    top: 15px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    display: block;\n    text-align: center;\n    color: black;\n}\n\n.text-input {\n    margin: 10px 8px !important;\n}\n\n.privacyterms {\n    font-size: 13px;\n    color: rgba(0, 0, 0, 0.87);\n    padding-left: 7px;\n    position: relative;\n    margin: auto 0;\n    color: #9ca579;\n}\n\nli {\n    color: white;\n}\n\ninput[type=\"number\"]::-webkit-inner-spin-button,\ninput[type=\"number\"]::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n\n#previmg {\n    position: relative;\n    border-radius: 50%;\n    bottom: 5px;\n    object-fit: cover;\n}\n\n@media only screen and (max-width: 500px) {\n    .label-text {\n        text-align: left !important;\n    }\n\n    #total-grid {\n        width: 100% !important;\n    }\n\n    .row {\n        padding-top: 0px !important;\n    }\n\n    .labelContent {\n        top: 1px !important;\n    }\n\n    .removableCol {\n        display: none !important;\n    }\n\n    #privacyCheckBox {\n        margin-left: 0px !important;\n    }\n\n    #previmg {\n        top: 25px !important;\n    }\n}\n\n.footer {\n    text-align: center;\n    font-size: 11px;\n    font-style: italic;\n    color: white;\n    background: #be1e2d;\n}\n\n.creation-success {\n    color: #00c09a;\n    font-size: 26px;\n    font-weight: 500;\n}\n\n.stepper {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.step {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    width: 100%;\n}\n\n.step:after {\n    content: \"\";\n    display: block;\n    width: 100%;\n    position: relative;\n    height: 5px;\n    background: #dee3e4;\n}\n\n.step:before {\n    content: \"\";\n    display: block;\n    width: 100%;\n    position: relative;\n    height: 5px;\n    background: #dee3e4;\n}\n\n.step:last-child {\n    flex-basis: 70%;\n}\n\n.step:last-child:after {\n    display: none;\n}\n\n.step:first-child {\n    flex-basis: 70%;\n}\n\n.step:first-child:before {\n    display: none;\n}\n\n.step.active {\n    color: white;\n}\n\n.step.active:before,\n.step.active:after {\n    background-color: #00c09a;\n}\n\n.step.active+.step:not(.active):before {\n    background-color: #00c09a;\n}\n\n.step-inner {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n}\n\n.step-circle {\n    border-radius: 20px;\n}\n\n.label-div {\n    position: relative;\n    bottom: 100%;\n    right: 0.8%;\n    top: -15px;\n}\n\n.info-content {\n    font-size: 11px;\n    color: white;\n}\n\n.header-row {\n    padding-top: 0px !important;\n}\n\n.e-multiselect.e-input-group.e-input-focus {\n    height: auto !important;\n}\n\n.e-checkbox-wrapper .e-frame.e-check {\n    background-color: #be1e2d !important;\n}\n\n.e-checkbox-wrapper:hover .e-frame.e-check {\n    background-color: #be1e2d !important;\n}\n\n.e-checkbox-wrapper .e-checkbox:focus+.e-frame.e-check {\n    background-color: #be1e2d !important;\n}\n\n@media only screen and (max-width: 768px) {\n    #total-grid {\n        border: 1px solid transparent;\n        width: 75% !important;\n    }\n}\n\n.dropdown-btn {\n    background: #fff;\n    min-height: 34px !important;\n    font-size: 14px;\n    border: 1px solid #adadad;\n    color: #adadad;\n}\n\n#sports_position_codes span {\n    color: #adadad;\n}\n\n#sports_position_codes .dropdown-list {\n    font-size: 14px;\n}\n\n#sports_position_codes span.selected-item {\n    background: gray !important;\n    color: #fff !important;\n    border: 1px solid gray;\n    border-radius: 5px;\n    margin-bottom: 10px;\n}\n\ninput[type=\"checkbox\"]+div:before {\n    border: 2px solid #be1e2d !important;\n}\n\ninput[type=\"checkbox\"]:disabled+div:before {\n    border-color: #ccc !important;\n}\n\ninput[type=\"checkbox\"]:checked+div:before {\n    background: #be1e2d !important;\n    border: 2px solid #be1e2d !important;\n}\n\n.multiSelectDisabled {\n    pointer-events: none;\n}\n\n.multiSelectActive {\n    pointer-events: unset;\n}\n\n.uploadButton {\n    color: white;\n    font-size: 14px;\n    margin-right: 20px;\n    margin-top: 10px;\n    background-color: #be1e2d;\n    height: 30px;\n    text-transform: uppercase;\n    width: 100px;\n    font-weight: 500;\n    border-radius: 5%;\n    -webkit-box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2),\n        0 1px 5px 0 rgba(0, 0, 0, 0.12);\n    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12);\n}\n\nspan.e-input-group.e-control-wrapper.e-date-wrapper {\n    margin-top: 8px;\n}\n\nbutton[disabled] {\n    cursor: default;\n    opacity: .4;\n    pointer-events: none;\n}\n\n.actionButton {\n    width: 100%;\n    color: #ffffff;\n    background: #be1e2d;\n    height: 42px;\n    font-size: 14px;\n    margin-top: 15px;\n}\n\n#sports_position_codes span.dropdown-btn {\n    background: #fff;\n    min-height: 34px !important;\n    font-size: 14px;\n    border: 1px solid #adadad;\n    color: #adadad;\n}\n\n#athleteBirthdate_input {\n    padding-left: 10px;\n    padding-top: 10px;\n}\n\n.cancel-btn {\n    height: 42px;\n    opacity: 0.7;\n    width: 100%;\n    background-color: #f4f4f4;\n    color: black;\n    margin-top: 15px;\n    font-size: 14px;\n}\n\n.add-btn {\n    background: transparent;\n    border-radius: 4px;\n    border: 1px solid #be1e2d;\n    color: #be1e2d;\n    font-size: 14px;\n    height: 42px;\n    width: 100%;\n}\n\n.select-btn {\n    color: #ffffff;\n    font-size: 14px;\n    background: #be1e2d;\n    height: 42px;\n    width: 100%;\n}\n\n.e-popup.e-multi-select-list-wrapper {\n    padding-top: calc(1px + env(safe-area-inset-top)) !important;\n}\n\n::ng-deep .addathlete-popover {\n    --width:278px;\n\n\n    .popover-viewport.sc-ion-popover-ios {\n        overflow-y: auto;\n    }\n\n    ion-item {\n        --inner-border-width: 0;\n        --background: #ffffff;\n        background: #ffffff;\n        --color: #000000;\n        color: #000000;\n        font-size: 13px !important;\n        height: 36px;\n        --background-focused-opacity: 0.08 !important;\n        --background-hover-opacity: 0.08 !important;\n\n        ion-label {\n            color: #000000 !important;\n            --color: #000000 !important;\n        }\n\n        ion-radio {\n            --color-checked: #be1e2d !important;\n        }\n    }\n}\n\n\n::ng-deep .level-popover {\n    --width:278px;\n    ion-item {\n        --inner-border-width: 0;\n        --background: #ffffff;\n        background: #ffffff;\n        --color: #000000;\n        color: #000000;\n        font-size: 13px !important;\n        height: 36px;\n        --background-focused-opacity: 0.08 !important;\n        --background-hover-opacity: 0.08 !important;\n\n        ion-label {\n            color: #000000 !important;\n            --color: #000000 !important;\n        }\n\n        ion-radio {\n            --color-checked: #be1e2d !important;\n        }\n    }\n}\n\ninput.maskinput:focus {\n    border: none;\n    outline-width: 0;\n    outline: 0;\n}\n\n#athletePhoneNumber {\n    padding: 7px;\n    font-size: 14px;\n}\n\nion-input{\n    margin: 0px;\n}\n\n@media only screen and (max-width: 550px){\n    #total-grid{\n        width: 90% ;\n    }\n    ::ng-deep .addathlete-popover{\n        --width:390px ;\n    }\n\n    ::ng-deep .level-popover{\n        --width:390px ;\n    }\n}\n\n\n\n::ng-deep .addathlete-popovermobile {\n    --width: 66%;\n    left: 0px;\n    .popover-viewport.sc-ion-popover-ios {\n        overflow-y: auto; \n    }\n    ion-item{\n        --inner-border-width: 0;\n        --background: #ffffff;\n        background: #ffffff;\n        --color: #000000;\n        color: #000000;\n        font-size: 13px !important;\n        height: 36px;\n        --background-focused-opacity: 0.08 !important;\n        --background-hover-opacity: 0.08 !important;\n        ion-label{\n            color: #000000 !important;\n            --color: #000000 !important;\n        }\n        ion-radio{\n            --color-checked:#be1e2d!important;\n        }\n    } \n}\n\n::ng-deep .addathlete-heightfeet-popover {\n    --width:133px;\n\n\n    .popover-viewport.sc-ion-popover-ios {\n        overflow-y: auto;\n    }\n\n    ion-item {\n        --inner-border-width: 0;\n        --background: #ffffff;\n        background: #ffffff;\n        --color: #000000;\n        color: #000000;\n        font-size: 13px !important;\n        height: 36px;\n        --background-focused-opacity: 0.08 !important;\n        --background-hover-opacity: 0.08 !important;\n\n        ion-label {\n            color: #000000 !important;\n            --color: #000000 !important;\n        }\n\n        ion-radio {\n            --color-checked: #be1e2d !important;\n        }\n    }\n}\n\n::ng-deep .level-popovermobile {\n    --width: 66%;\n    left: 0px;\n    --height : 40% !important;\n    ion-item{\n        --inner-border-width: 0;\n        --background: #ffffff;\n        background: #ffffff;\n        --color: #000000;\n        color: #000000;\n        font-size: 13px !important;\n        height: 36px;\n        --background-focused-opacity: 0.08 !important;\n        --background-hover-opacity: 0.08 !important;\n        ion-label{\n            color: #000000 !important;\n            --color: #000000 !important;\n        }\n        ion-radio{\n            --color-checked:#be1e2d!important;\n        }\n    } \n}\n    \n.e-multiselect .e-down-icon .e-chips-close.e-close-hooker{\n\tmargin-top: -30px !important;\n}\n\n.e-multi-select-wrapper .e-delim-values{\n    line-height: 35px !important;\n}\n\n.e-multiselect .e-input-group-icon.e-ddl-icon {\n    margin-top: 9px !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
